import * as React from 'react';
import './index.scss';
import { StageDefault } from '@/context.ts';
import HourRank from '@hooks/web/public/hourRank.tsx';
import RichRank from '@hooks/web/public/richRank.tsx';
import GroupRank from '@hooks/web/public/groupRank.tsx';
import GroupFinal from '@hooks/web/public/groupFinal.tsx';
import PkRank from '@hooks/web/public/pkRank.tsx';
interface TabsType {
  current: number,
  title: string,
  time: string,
  tips: string,
}
const { useEffect, useState, useContext } = React;
const Tab2: React.FC = () => {
  const { iStage, tabToastOpen } = useContext(StageDefault);
  const [IStage] = useState<number>(iStage > 4 ? 4 : iStage);
  const [current, Current] = useState<number>(iStage >= 4 ? 5 : iStage);
  const [sendIStage, SendIStage] = useState<number>(iStage > 4 ? 4 : iStage);
  const [tabs] = useState<TabsType[]>([
    {
      current: 1,
      title: 'N进12',
      time: '11.13-11.15',
      tips: '星光值排名前12名的公会晋级下一回合',
    },
    {
      current: 2,
      title: '12进8',
      time: '11.16-11.17',
      tips: '星光值排名前8名的公会晋级下一回合',
    },
    {
      current: 3,
      title: '8进6',
      time: '11.18-11.19',
      tips: '星光值排名前6名的公会晋级下一回合',
    },
    {
      current: 3,
      title: '复活赛',
      time: '11.18-11.19',
      tips: '排名前N名的公会复活进入决赛，N为8进6阶段晋级决赛的公会中获得金牌公会的数量',
    },
    {
      current: 4,
      title: '决赛',
      time: '11.20-11.21',
      tips: '决出虎牙年度最强游戏/娱乐公会冠亚季军',
    },
  ])
  return (
    <div
      className='web-tab2'
    >
      <div className='tab2_nav'>
        {
          [tabs].map((item: any, index: number) => (
            <ul key={index}>
              {
                item.map((navItem: TabsType, Index: number) => (
                  <li
                    key={Index}
                    className={
                      current === (Index + 1) ? 'on' : ''
                    }
                    onClick={
                      () => {
                        if (Index + 1 === 4 && IStage >= 3) {
                          SendIStage(3);
                          Current(4);
                          return;
                        }
                        if (Index + 1 === 5 && IStage >= 4) {
                          SendIStage(4);
                          Current(5);
                          return;
                        }
                        if (Index + 1 > IStage) {
                          tabToastOpen('该赛程暂未开始，敬请期待');
                          return;
                        };
                        SendIStage(Index + 1);
                        Current(Index + 1);
                      }
                    }
                  >
                    <h2>{navItem.title}</h2>
                    <i></i>
                    <p>{navItem.time}</p>
                    <div className='tab-tips'>{navItem.tips}</div>
                  </li>
                ))
              }
            </ul>
          ))
        }
      </div>
      <HourRank iStage={sendIStage} />
      { sendIStage !== 4 ? <GroupRank iStage={sendIStage} from={2} iRevive={current === 4 ? 1 : 0} /> : <GroupFinal iStage={sendIStage} />}
      <RichRank />
      <PkRank iStage={sendIStage} iRevive={current === 4 ? 1 : 0} from={2} />
    </div>
  )
}

export default Tab2;